import en from "./en";
import ja from "./ja";

const translations = { en, ja };

export function getLang() {
    return localStorage.getItem("lang") || "en";
}

export function setLang(lang) {
    localStorage.setItem("lang", lang);
    window.dispatchEvent(new Event("langChanged"));
}
export function t(key) {
    if (typeof key !== 'string' || key === '') {
        return '';
    }

    const lang = getLang();
    const parts = key.split('.');
    let obj = translations?.[lang];

    for (const p of parts) {
        if (!obj || typeof obj !== 'object') {
            return key;
        }
        obj = obj[p];
    }

    return typeof obj === 'string' ? obj : key;
}